import { createState } from "@hookstate/core";
import { AppState } from "./types";

export const state = createState<AppState>({
  confirmationModal: {
    open: false,
  },
  requestPaymentModal: {
    open: false,
  },
  withdrawFundsModal: {
    open: false,
  },
});
